module.exports = __webpack_public_path__ + "components/rewards/snowtrex/static/logo-55ba6106e86cd6f5e6b29d1a940792f1.png";